import { render } from "./dialog-auth.vue?vue&type=template&id=08ca7379&scoped=true"
import script from "./dialog-auth.ts?vue&type=script&lang=js&external"
export * from "./dialog-auth.ts?vue&type=script&lang=js&external"

import "./dialog-auth.vue?vue&type=style&index=0&id=08ca7379&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ca7379"]])

export default __exports__